/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@/api/common/client';
import type {
  PostApiEmployeesIdCvRequestUpdateMutationRequest,
  PostApiEmployeesIdCvRequestUpdateMutationResponse,
  PostApiEmployeesIdCvRequestUpdatePathParams,
} from '../models/PostApiEmployeesIdCvRequestUpdate.ts';
import type { RequestConfig, ResponseErrorConfig } from '@/api/common/client';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import {
  postApiEmployeesIdCvRequestUpdateMutationResponseSchema,
  postApiEmployeesIdCvRequestUpdateMutationRequestSchema,
} from '../zod/postApiEmployeesIdCvRequestUpdateSchema.ts';
import { useMutation } from '@tanstack/react-query';

export const postApiEmployeesIdCvRequestUpdateMutationKey = () =>
  [{ url: '/api/employees/:id/cv/request-update' }] as const;

export type PostApiEmployeesIdCvRequestUpdateMutationKey = ReturnType<
  typeof postApiEmployeesIdCvRequestUpdateMutationKey
>;

/**
 * {@link /api/employees/:id/cv/request-update}
 */
export async function postApiEmployeesIdCvRequestUpdate(
  id: PostApiEmployeesIdCvRequestUpdatePathParams['id'],
  data?: PostApiEmployeesIdCvRequestUpdateMutationRequest,
  config: Partial<
    RequestConfig<PostApiEmployeesIdCvRequestUpdateMutationRequest>
  > & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData =
    postApiEmployeesIdCvRequestUpdateMutationRequestSchema.parse(data);
  const res = await request<
    PostApiEmployeesIdCvRequestUpdateMutationResponse,
    ResponseErrorConfig<Error>,
    PostApiEmployeesIdCvRequestUpdateMutationRequest
  >({
    method: 'POST',
    url: `/api/employees/${id}/cv/request-update`,
    data: requestData,
    ...requestConfig,
  });
  return postApiEmployeesIdCvRequestUpdateMutationResponseSchema.parse(
    res.data,
  );
}

/**
 * {@link /api/employees/:id/cv/request-update}
 */
export function usePostApiEmployeesIdCvRequestUpdate<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiEmployeesIdCvRequestUpdateMutationResponse,
      ResponseErrorConfig<Error>,
      {
        id: PostApiEmployeesIdCvRequestUpdatePathParams['id'];
        data?: PostApiEmployeesIdCvRequestUpdateMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiEmployeesIdCvRequestUpdateMutationRequest>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiEmployeesIdCvRequestUpdateMutationKey();

  return useMutation<
    PostApiEmployeesIdCvRequestUpdateMutationResponse,
    ResponseErrorConfig<Error>,
    {
      id: PostApiEmployeesIdCvRequestUpdatePathParams['id'];
      data?: PostApiEmployeesIdCvRequestUpdateMutationRequest;
    },
    TContext
  >(
    {
      mutationFn: async ({ id, data }) => {
        return postApiEmployeesIdCvRequestUpdate(id, data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
